import type { ErrorStrategy } from '@/validation/types';
import { t } from 'i18next';

export const oneOfStrategy: ErrorStrategy = ({ instancePath }) => {
  return {
    // Every failed validation within 'anyOf' will generate a validation error,
    // this one will come last and therefore overwrite the displayed message.
    // We just show the format validation error, since there are several
    // error strategies behind an anyOf definition. Identifying the error
    // would mean that we somehow need to merge the errors of all strategies.
    path: instancePath,
    message: t('WrongFormat'),
  };
};
